module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"NaNSYSTEMS.us","short_name":"NaNSYSTEMS.us","start_url":"/","background_color":"#FBFAF7","theme_color":"#1C2541","display":"standalone","icon":"src/media-imgs/favIcon.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"1ccde7309bbf3fe19530d6af809757de"},
    },{
      plugin: require('../node_modules/gatsby-plugin-scroll-reveal/gatsby-browser.js'),
      options: {"plugins":[],"threshold":0.5},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
